import { useState } from "react";
import { createContainer } from "unstated-next";
import { ToastProps } from "task-eva-ui";
export function useToastStoreHook() {
  const [toastProps, setToastProps] = useState<ToastProps>({
    show: false,
  });
  const setShowToast = (show = true) => {
    setToastProps({
      ...toastProps,
      show,
    });
  };
  const showGlobalToast = (props: ToastProps) => {
    setToastProps({
      ...props,
      show: true,
    });
  };
  const updateGlobalToast = (params: ToastProps) => {
    setToastProps((pre) => ({
      duration: 1500,
      ...pre,
      ...params,
    }));
  };

  return {
    toastProps,
    setToastProps,
    showGlobalToast,
    setShowToast,
    updateGlobalToast,
  };
}

const ToastStoreContainer = createContainer(useToastStoreHook);

export const ToastStoreProvider = ToastStoreContainer.Provider;

export function useToastStore() {
  return ToastStoreContainer.useContainer();
}
